import { render, staticRenderFns } from "./live-pusher.vue?vue&type=template&id=72bcd978&scoped=true&"
import script from "./live-pusher.vue?vue&type=script&lang=js&"
export * from "./live-pusher.vue?vue&type=script&lang=js&"
import style0 from "./live-pusher.vue?vue&type=style&index=0&id=72bcd978&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bcd978",
  null
  
)

export default component.exports